// extracted by mini-css-extract-plugin
module.exports = {"container":"RoleSelect_container_3ExjM","label":"RoleSelect_label_2mHo7"};